var map = {
	"./biopic.jpeg": 792,
	"./budgettracker.png": 130,
	"./codconnect.png": 271,
	"./favicon.ico": 329,
	"./fridgetofeast.png": 796,
	"./hoirseonimg.png": 906,
	"./memoji.png": 451,
	"./memoji.svg": 492,
	"./notetaker.png": 848,
	"./placeholder.png": 388,
	"./portfolioLogo.png": 494,
	"./portfolioLogo.svg": 790,
	"./runbuddyimg.png": 169,
	"./screenshot.png": 344,
	"./techblog.png": 227,
	"./weatherdashboard.png": 981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;